<template>
  <v-dialog :value="true" persistent max-width="400" v-if="order && order.payment_form && order.payment_form.id === 11 && order.collection_document">
    <v-card>
      <v-card-title><span class="title-modal">Pagamento por Pix</span></v-card-title>
      <p class="paragraph-modal">Pague com <b>Pix</b> em qualquer dia e a qualquer hora! O Pagamento é
        instantâneo,prático e pode ser feito em poucos segundos. É muito rápido e seguro :)</p>
      <div class="qrcode">
        <vue-qrcode :value="order.collection_document.bar_code" :options="{ width: 300 }"></vue-qrcode>
        <div class="code">
          <p>{{ order.collection_document.bar_code }}</p>
        </div>
        <div class="text">
          <span><b>Código válido até:</b> </span>
          <span>{{ new Date(order.collection_document.extra.expired_at).toLocaleString() }}</span>
          <span><b>Valor:</b> </span>
          <span>R$ {{ order.total_amount | integerToMoney | integerToMoney2 }}</span>
        </div>
        <div class="steps">
          <p>1. Abra o app do seu banco</p>
          <p>2. Escolha a opção Pagar com QrCode</p>
          <p>3. Confirme as informações e finalize o pagamento</p>
          <p>4. Aguarde e em breve você será notificado</p>
        </div>
      </div>
      <v-card-actions>
        <div class="flex-grow-1 text-right">
          <v-btn class="btn-confirm" @click.prevent="refreshPage()">Voltar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  name: 'pix-dialog',
  components: {VueQrcode},
  props: {
    order: {}
  }
}
</script>
<style scoped>

.title-modal {
  word-break: normal;
  text-align: center;
  margin: auto;
}

.paragraph-modal {
  text-align: center;
  font-size: 16px;
  padding: 0 20px;
}

.qrcode {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrcode .text {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  padding: 0 20px;
}

.qrcode .code {
  width: 100%;
  padding: 0 20px;
}

.qrcode .steps {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 20px;
  padding-top: 20px;
}

.qrcode .steps p {
  margin: unset;
}

.qrcode span {
  font-size: 16px;
  color: #3f3f3f;
  margin: unset;
}

@media only screen and (max-width: 500px) {

  .v-stepper__content button {
    width: 100%;
    margin: 5px 0;
  }

}
</style>